import { render, staticRenderFns } from "./ResetPassPage.vue?vue&type=template&id=1b279c44"
import script from "./ResetPassPage.vue?vue&type=script&lang=js"
export * from "./ResetPassPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports